import { ReduceStore } from "flux/utils";
import AppDispatcher from "../AppDispatcher";
import Constants from "../Constants";
import { Record, Map } from "immutable";

export const Organization = Record({
  id: null,
  name: null,
  defaultTableauUser: null,
  requiredEulaContentId: null,
  gaTag: null,
});

/**
 * Patches organization with some org-specific values not currently stored in user-service.
 * @param {Organization} org
 * @returns {Organization}
 */
const patchOrganization = (org) => {
  return addAnalyticsTag(flagEulaOrganization(org));
};

/**
 * Adds google analytics org-specific tag.
 * @param {Organization} org org to patch
 * @returns {Organization} patched org
 */
const addAnalyticsTag = (org) => {
  switch (org.id) {
    case 31:
      return org.set("gaTag", "G-ZP86J2S2C5");
  }
  return org;
};

const flagEulaOrganization = (org) => {
  switch (org.id) {
    case 31:
      return org.set("requiredEulaContentId", "5BFhmTLR5ygnrHqBUvEu8l");
    case 50:
      return org.set("requiredEulaContentId", "5BFhmTLR5ygnrHqBUvEu8l");
  }
  return org;
};

function loadOrganizationsFromUser(state, user) {
  const newValues = new Map(
    user.memberships.map((membership) => [
      membership.organization.id,
      patchOrganization(
        new Organization({
          id: membership.organization.id,
          name: membership.organization.name,
        })
      ),
    ])
  );
  return state.merge(newValues);
}

class OrganizationStore extends ReduceStore {
  getInitialState() {
    return new Map();
  }

  reduce(state, action) {
    switch (action.actionType) {
      case Constants.Admin.ORGANIZATION_LOADED:
        return state.set(
          action.organization.id,
          patchOrganization(
            new Organization({
              id: action.organization.id,
              name: action.organization.name,
              defaultTableauUser:
                action.organization.organization_detail.default_tableau_user,
            })
          )
        );
      case Constants.Admin.CURRENT_USER_LOADED:
        return loadOrganizationsFromUser(state, action.user);
      default:
        return state;
    }
  }

  /**
   *
   * @param {*} id organization to get
   * @param {*} defaultValue
   * @return {Organization}
   */
  get(id, defaultValue = null) {
    return this.getState().get(id, defaultValue);
  }
}

const instance = new OrganizationStore(AppDispatcher);
export default instance;
